(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8255],{

/***/ 97910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconExternal = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M16 12.73V8.285h-.9v4.415a2.402 2.402 0 0 1-2.398 2.4H3.298A2.402 2.402 0 0 1 .9 12.7V3.298A2.402 2.402 0 0 1 3.298.9h4.39V0h-4.39A3.292 3.292 0 0 0 0 3.298v9.404A3.292 3.292 0 0 0 3.298 16h9.404C14.527 16 16 14.527 16 12.73Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M15.1 4.825v-3.27L8.068 8.587l-.654-.654L14.447.901h-3.271V0H16v4.824h-.9Z",
  fill: "#B18D3B"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconExternal);

/***/ }),

/***/ 51036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_Message; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-message.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMessage = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 32,
  height: 37,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M31.125 36.5H.875a.497.497 0 0 1-.494-.497L.385 15.72a.494.494 0 1 1 .988 0L1.37 35.508H30.63l-.004-19.787a.494.494 0 1 1 .988 0l.004 20.281a.493.493 0 0 1-.493.497Z",
  fill: "#999"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M16.004 30.144h-.012a.484.484 0 0 1-.334-.131L.546 16.085a.496.496 0 0 1 .67-.728L16 28.981l14.783-13.624a.496.496 0 0 1 .7.029c.185.2.17.512-.029.699L16.341 30.01a.492.492 0 0 1-.337.133Z",
  fill: "#999"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M31.124 36.498a.486.486 0 0 1-.291-.096l-12.245-9.005a.498.498 0 0 1-.106-.692.498.498 0 0 1 .692-.106l12.245 9.005c.22.163.266.47.106.692a.502.502 0 0 1-.4.203ZM.875 36.5a.494.494 0 0 1-.292-.895L12.829 26.6a.494.494 0 1 1 .586.799L1.17 36.404a.498.498 0 0 1-.295.096ZM25.712 21.198a.494.494 0 0 1-.494-.494V5.562H6.781v15.14a.494.494 0 1 1-.988 0V5.069c0-.273.22-.494.494-.494h19.425c.273 0 .494.221.494.494v15.635c0 .273-.22.495-.494.495Z",
  fill: "#999"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M11.885 5.562a.494.494 0 0 1-.348-.845L15.65.643a.494.494 0 1 1 .697.703l-4.114 4.073a.498.498 0 0 1-.348.143Z",
  fill: "#999"
})), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
  d: "M20.106 5.563a.492.492 0 0 1-.348-.143l-4.106-4.075a.495.495 0 0 1 .696-.702l4.106 4.075a.495.495 0 0 1-.348.845ZM.881 16.218a.494.494 0 0 1-.343-.848l5.408-5.265a.494.494 0 1 1 .689.709l-5.409 5.262a.496.496 0 0 1-.345.142ZM31.12 16.216a.49.49 0 0 1-.345-.141l-5.407-5.265a.496.496 0 0 1 .69-.71l5.406 5.266a.495.495 0 0 1-.343.85Z",
  fill: "#999"
})), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
  d: "M16 21.395a6.066 6.066 0 0 1-4.324-1.793 6.068 6.068 0 0 1-1.793-4.324c0-1.634.635-3.17 1.793-4.325A6.06 6.06 0 0 1 16 9.16c1.634 0 3.17.636 4.325 1.793a6.064 6.064 0 0 1 1.793 4.325c0 1.633-.635 3.169-1.793 4.324A6.08 6.08 0 0 1 16 21.395Zm0-11.247a5.136 5.136 0 0 0-5.129 5.13 5.136 5.136 0 0 0 5.13 5.13 5.136 5.136 0 0 0 5.129-5.13c0-2.83-2.302-5.13-5.13-5.13Z",
  fill: "#B18D3B"
})), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
  d: "M14.849 17.761a.478.478 0 0 1-.348-.146l-1.685-1.68a.496.496 0 0 1 .7-.7l1.334 1.336 3.633-3.634a.495.495 0 0 1 .7.7L15.2 17.618a.494.494 0 0 1-.351.143Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_message = (SvgIconMessage);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
// EXTERNAL MODULE: ./components/custom/Message/styles.module.scss
var styles_module = __webpack_require__(14234);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/custom/Message/index.js






var Message = function(param) {
    var title = param.title, subtitle = param.subtitle, button = param.button, _type = param.type, type = _type === void 0 ? "success" : _type;
    var handleCloseModal = (0,modalProvider/* useModalContext */.vR)().handleCloseModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,withModifiers/* withModifiers */.i)("message", [
            type
        ], (styles_module_default())),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_message, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (styles_module_default()).message__title,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).message__subtitle,
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                onClick: function() {
                    return handleCloseModal();
                },
                href: button.href && button.href,
                arrow: button === null || button === void 0 ? void 0 : button.arrow,
                children: button.label
            })
        ]
    });
};
/* harmony default export */ var custom_Message = (Message);


/***/ }),

/***/ 20027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var LazyImage = function(_param) {
    var src = _param.src, index = _param.index, width = _param.width, height = _param.height, alt = _param.alt, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "index",
        "width",
        "height",
        "alt"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), blur = ref[0], setBlur = ref[1];
    var getSmallImageSrc = function(src) {
        // Ensure src is a string before calling replace
        if (typeof src === "string") {
            return src.replace(/\b(1980|3840|640|960|360)\b/g, "64");
        }
        return null;
    };
    var isLayout = props.layout === "fill";
    // Filter out srcSet and sizes from props as Next.js Image doesn't support them directly
    // eslint-disable-next-line no-unused-vars
    var srcSet = props.srcSet, sizes = props.sizes, imageProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "srcSet",
        "sizes"
    ]);
    // Only render if src is a valid string
    if (src && typeof src === "string") {
        var blurDataURL = getSmallImageSrc(src);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            width: !isLayout && (width || 590),
            height: !isLayout && (height || 393),
            src: src,
            style: {
                objectFit: "cover"
            },
            blurDataURL: blurDataURL,
            placeholder: blurDataURL ? "blur" : "empty",
            className: blur ? "img-blur" : "unblur",
            onLoadingComplete: function() {
                return setBlur(false);
            },
            alt: alt || "Property presentation image ".concat(index)
        }, imageProps));
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyImage);


/***/ }),

/***/ 24447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6644);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34495);
/* harmony import */ var _LazyImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20027);
/* eslint-disable react/prop-types */ 









var CloudflareVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69562)
            ];
        }
    }
});
var Section = function(_param) {
    var children = _param.children, className = _param.className, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, bg = _param.bg, _video = _param.video, video = _video === void 0 ? false : _video, cloudflare = _param.cloudflare, _separator = _param.separator, separator = _separator === void 0 ? false : _separator, sectionRef = _param.sectionRef, _grayscale = _param.grayscale, grayscale = _grayscale === void 0 ? false : _grayscale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "variant",
        "bg",
        "video",
        "cloudflare",
        "separator",
        "sectionRef",
        "grayscale"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: sectionRef,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(variant).concat([
            separator && "has-separator",
            bg && "with-bg"
        ]), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())), className)
    }, props), {
        children: [
            bg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: bg,
                priority: true,
                objectPosition: "center",
                objectFit: "cover",
                sizes: "(max-width: 360px) 960px, (max-width: 640px) 960px, (max-width: 1400px) 1400px, 1980px",
                alt: "section background image",
                layout: "fill"
            }),
            (cloudflare || video) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section__video", [
                    grayscale && "grayscale"
                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloudflareVideo, {
                        name: "Section presentation video",
                        autoplay: true,
                        loop: true,
                        muted: true,
                        src: cloudflare || video
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__overlay)
                    })
                ]
            }),
            separator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__separator)
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Section);


/***/ }),

/***/ 47944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64636);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41197);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19403);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92375);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _providers_modalProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51472);
/* harmony import */ var _custom_Message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51036);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34495);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);











var Subscribe = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? [] : _variant, translations = param.translations;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), mails = ref[0], setMails = ref[1];
    var ref1 = (0,_providers_modalProvider__WEBPACK_IMPORTED_MODULE_5__/* .useModalContext */ .vR)(), handleShowModal = ref1.handleShowModal, setContent = ref1.setContent, setVariant = ref1.setVariant;
    var isLarge = variant.includes("large");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var formInitialValues = {
        email: ""
    };
    var validationSchema = function(values) {
        var errors = {};
        if (values.email !== "") {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = translations.error.emailError[router.locale];
            }
        }
        return errors;
    };
    var handleSubmit = function(values, param) {
        var setSubmitting = param.setSubmitting;
        setSubmitting(true);
        _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("active/pipe", {
            email: values.email
        }).then(function(res) {
            var ref, ref1;
            if ((ref = res.data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.error) === null || ref1 === void 0 ? void 0 : ref1.includes(translations.error.emailExists[router.locale])) {
                setMails((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(mails).concat([
                    values.email
                ]));
            } else {
                setVariant([
                    "contained",
                    "xs"
                ]);
                setContent(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Message__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    title: translations.success.title[router.locale],
                    subtitle: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            translations.success.subtitle[router.locale],
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                rel: "nofollow",
                                href: "mailto:reservations@stmartinsothebysrealty.com",
                                children: "reservations@stmartinsothebysrealty.com"
                            })
                        ]
                    }),
                    button: {
                        label: translations.success.button[router.locale],
                        href: "/vacation-rentals"
                    }
                }));
                handleShowModal();
            }
        }).catch(function(err) {
            return console.error(err);
        });
        setSubmitting(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
        initialValues: formInitialValues,
        enableReinitialize: true,
        validate: validationSchema,
        onSubmit: handleSubmit,
        children: function(param) {
            var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur;
            var disabled = values.email === formInitialValues.email || mails.includes(values.email) || errors.email && touched.email;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_9__/* .withModifiers */ .i)("form", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default())),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                        type: "email",
                        name: "email",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.email,
                        placeholder: isLarge ? translations.fields.email[router.locale] : translations.fields.subscribe[router.locale],
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().form__field)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().form__error),
                        children: [
                            errors.email && touched.email && errors.email,
                            mails.includes(values.email) && translations.error.subscribed[router.locale]
                        ]
                    }),
                    !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        variant: [
                            isLarge ? "primary-blue" : "secondary"
                        ],
                        name: "subscribe",
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().form__button),
                        children: isLarge ? translations.fields.submit[router.locale] : ""
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Subscribe);


/***/ }),

/***/ 8255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ general_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/elements/LazyImage/index.js
var LazyImage = __webpack_require__(20027);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./components/configs/axios.js
var axios = __webpack_require__(92375);
// EXTERNAL MODULE: ./providers/authProvider.js
var authProvider = __webpack_require__(89149);
;// CONCATENATED MODULE: ./components/general/Footer/navigation.js
/* eslint-disable prettier/prettier */ 



var navigation = function() {
    var ref = (0,authProvider/* useAuthContext */.Eu)(), loggedIn = ref.loggedIn, setLoggedIn = ref.setLoggedIn, seIsAgent = ref.seIsAgent, setUser = ref.setUser;
    var logout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var headers;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        headers = {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(loggedIn)
                        };
                        _ctx.next = 3;
                        return axios/* default.post */.Z.post("auth/logout", "", {
                            headers: headers
                        }).then(function() {
                            localStorage.removeItem("access_token");
                            localStorage.removeItem("isAgent");
                            setLoggedIn(false);
                            seIsAgent(false);
                            setUser(false);
                        }).catch(function(err) {
                            console.error(err);
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function logout() {
            return _ref.apply(this, arguments);
        };
    }();
    return [
        {
            title: {
                en: "Vacation Rentals",
                fr: "Locations saisonni\xe8res",
                es: "Alquileres de vacaciones",
                nl: "vakantiewoningen"
            },
            links: [
                {
                    title: "St. Martin Destination",
                    link: "/vacation-rentals?location=terres-basses&location=grand-case&location=happy-bay&location=orient-bay"
                },
                {
                    title: "St. Maarten Destination",
                    link: "/vacation-rentals?location=cupecoy&location=indigo-bay&location=pelican&location=simpson-bay"
                },
                {
                    title: "Exclusive Properties",
                    link: "/vacation-rentals?homeType=exclusive"
                },
                {
                    title: "Beachfront Properties",
                    link: "/vacation-rentals?amenities=beachfront"
                },
                {
                    title: "Villas",
                    link: "/vacation-rentals?homeType=villa"
                },
                {
                    title: "Condos",
                    link: "/vacation-rentals?homeType=condominium"
                },
                {
                    title: "Calendar",
                    link: "/calendar"
                }
            ]
        },
        {
            title: {
                en: "Real Estate",
                fr: "Immobilier",
                es: "Bienes ra\xedces",
                nl: "Vastgoed"
            },
            links: [
                {
                    title: "Buy and Sell with Us",
                    link: "/real-estate"
                },
                {
                    title: "Exclusive St Martin Sotheby's Realty",
                    link: "/real-estate/search?homeType=exclusive"
                }
            ]
        },
        {
            title: {
                en: "Company",
                fr: "Entreprise",
                es: "Compa\xf1\xeda",
                nl: "Bedrijf"
            },
            links: [
                {
                    title: "Guest Experience",
                    link: "/guest-experience"
                },
                {
                    title: "About Us",
                    link: "/about-us"
                },
                {
                    title: "FAQs",
                    link: "/frequently-asked-questions"
                },
                {
                    title: "Stories",
                    link: "/stories"
                },
                !loggedIn && {
                    title: "Login",
                    link: "/login"
                },
                !loggedIn && {
                    title: "Register",
                    link: "/register"
                },
                loggedIn && {
                    title: "Logout",
                    action: function() {
                        return logout();
                    }
                }
            ]
        },
        {
            title: {
                en: "Contact",
                fr: "contacter",
                es: "contactar",
                nl: "communicatie"
            },
            links: [
                {
                    title: "Contact Us",
                    link: "/contact"
                },
                {
                    title: "Privacy Policy",
                    link: "/privacy-policy"
                },
                {
                    title: "Terms of Use",
                    link: "/terms"
                },
                {
                    title: "Sitemap",
                    link: "#",
                    disabled: true
                }
            ]
        },
        {
            title: {
                en: "Socials",
                fr: "r\xe9seaux sociaux",
                es: "Sociales",
                nl: "Sociaal"
            },
            links: [
                {
                    title: "Facebook",
                    social: true,
                    link: "https://www.facebook.com/stmartinsothebysrealty/"
                },
                {
                    title: "Twitter",
                    social: true,
                    link: "https://twitter.com/SXMSIR"
                },
                {
                    title: "Instagram",
                    social: true,
                    link: "https://www.instagram.com/sxmsir"
                },
                {
                    title: "LinkedIn",
                    social: true,
                    link: "https://www.linkedin.com/company/stmartinsothebysrealty"
                },
                {
                    title: "YouTube",
                    social: true,
                    link: "https://www.youtube.com/channel/UCjnr48kipvnQZnxPiSlluLQ"
                }
            ]
        }
    ];
};
/* harmony default export */ var Footer_navigation = (navigation);

// EXTERNAL MODULE: ./components/general/Footer/styles.module.scss
var styles_module = __webpack_require__(24055);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/general/Footer/components/Form/index.js
var Form = __webpack_require__(47944);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./public/icons/icon-external.svg
var icon_external = __webpack_require__(97910);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseHas.js
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseHas_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && _baseHas_hasOwnProperty.call(object, key);
}

/* harmony default export */ var _baseHas = (baseHas);

// EXTERNAL MODULE: ./node_modules/lodash-es/_hasPath.js
var _hasPath = __webpack_require__(16174);
;// CONCATENATED MODULE: ./node_modules/lodash-es/has.js



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && (0,_hasPath/* default */.Z)(object, path, _baseHas);
}

/* harmony default export */ var lodash_es_has = (has);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/general/Footer/index.js

















var Footer = function(param) {
    var translations = param.translations;
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isTablet = ref.isTablet, isSmallMobile = ref.isSmallMobile, isMobile = ref.isMobile;
    var router = (0,next_router.useRouter)();
    var currentYear = moment_default()().utc().year();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: (styles_module_default()).footer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
            variant: [
                "bg-body"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).footer__section,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns/* default */.Z, {
                            variant: [
                                "-align-middle",
                                "no-gutter"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                    variant: [
                                        "no-padding"
                                    ],
                                    spans: isSmallMobile ? 12 : isTablet ? 3 : 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                                        alt: "Sotheby's Realty logo",
                                        src: "/logos/logo-stmartin-footer.svg",
                                        width: 116,
                                        height: 87
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                                    spans: isSmallMobile ? 12 : isMobile ? 9 : 7,
                                    variant: [
                                        "grow",
                                        isSmallMobile && "no-padding"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).footer__title,
                                            children: translations.subscribe[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (styles_module_default()).footer__description,
                                            children: translations.description[router.locale]
                                        }),
                                        isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                                            translations: translations.form
                                        })
                                    ]
                                }),
                                !isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                    variant: [
                                        "no-padding"
                                    ],
                                    spans: isSmallMobile ? 12 : 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                                        translations: translations.form
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).footer__section,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                            variant: [
                                isTablet ? "-align-center" : "-distribute-between"
                            ],
                            className: (styles_module_default()).footer__wrapper,
                            children: Footer_navigation().map(function(column, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                                    className: (styles_module_default()).footer__column,
                                    spans: isSmallMobile ? 6 : isTablet && 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).footer__heading,
                                            children: column.title[router.locale]
                                        }),
                                        column.links.map(function(item, value) {
                                            if (item) {
                                                if (item.link) {
                                                    if (item.social) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: (0,withModifiers/* withModifiers */.i)("footer__link", [
                                                                router.asPath === item.link && "is-active",
                                                                item.disabled && "disabled"
                                                            ], (styles_module_default())),
                                                            target: "_blank",
                                                            href: item.link,
                                                            rel: "noreferrer",
                                                            children: [
                                                                item.title,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_external/* default */.Z, {})
                                                            ]
                                                        }, "link-".concat(index, "-").concat(value));
                                                    } else {
                                                        var ref;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: item.link,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: (0,withModifiers/* withModifiers */.i)("footer__link", [
                                                                    router.asPath === item.link && "is-active",
                                                                    item.disabled && "disabled"
                                                                ], (styles_module_default())),
                                                                children: (ref = translations[item.title.toLowerCase().replaceAll(" ", "").replaceAll("'", "").replaceAll(".", "")]) === null || ref === void 0 ? void 0 : ref[router.locale]
                                                            })
                                                        }, "link-".concat(index, "-").concat(value));
                                                    }
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                                    arrow: false,
                                                    variant: [
                                                        "label"
                                                    ],
                                                    onClick: function() {
                                                        return item.action && item.action();
                                                    },
                                                    className: (0,withModifiers/* withModifiers */.i)("footer__link", [
                                                        router.asPath === item.link && "is-active",
                                                        !lodash_es_has(item, "action") && "disabled"
                                                    ], (styles_module_default())),
                                                    children: item.title
                                                }, "link-".concat(index, "-").concat(value));
                                            }
                                            return;
                                        })
                                    ]
                                }, "column-".concat(index));
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).footer__section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Copyright \xa9 ",
                                    currentYear,
                                    " ",
                                    translations.copyright[router.locale]
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (styles_module_default()).footer__copyright,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).highlight,
                                        children: translations.copyrightHighlight[router.locale]
                                    }),
                                    " ",
                                    translations.copyrightDescription[router.locale]
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var general_Footer = (Footer);


/***/ }),

/***/ 89149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eu": function() { return /* binding */ useAuthContext; },
/* harmony export */   "HD": function() { return /* binding */ AuthContextProvider; }
/* harmony export */ });
/* unused harmony export AuthContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var AuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useAuthContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AuthContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var AuthContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isAgent = ref1[0], seIsAgent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), user = ref2[0], setUser = ref2[1];
    var isAuthorized = loggedIn && isAgent;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // When storage changes refetch
        setLoggedIn(localStorage.getItem("access_token") || false);
        seIsAgent(localStorage.getItem("isAgent") || false);
        setUser(localStorage.getItem("user") || false);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthContext.Provider, {
        value: {
            loggedIn: loggedIn,
            setLoggedIn: setLoggedIn,
            isAgent: isAgent,
            seIsAgent: seIsAgent,
            isAuthorized: isAuthorized,
            user: user,
            setUser: setUser
        },
        children: children
    });
};



/***/ }),

/***/ 51472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ny": function() { return /* binding */ ModalContextProvider; },
/* harmony export */   "vR": function() { return /* binding */ useModalContext; }
/* harmony export */ });
/* unused harmony export ModalContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useModalContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var ModalContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), variant = ref2[0], setVariant = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), beforeClose = ref3[0], handleBeforeClose = ref3[1];
    var body =  true && document.querySelector("body");
    var handleShowModal = function() {
        setShow(true);
        body.classList.add("modal-open");
    };
    var handleCloseModal = function() {
        setShow(false);
        body.classList.remove("modal-open");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) {
            beforeClose && beforeClose();
            handleCloseModal();
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: {
            handleShowModal: handleShowModal,
            handleCloseModal: handleCloseModal,
            handleBeforeClose: handleBeforeClose,
            setContent: setContent,
            content: content,
            setVariant: setVariant,
            show: show,
            variant: variant
        },
        children: children
    });
};



/***/ }),

/***/ 14234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__IQwiF","message__title":"styles_message__title__GlV0y","message__subtitle":"styles_message__subtitle__BZWor","message--error":"styles_message--error__hmqU0"};

/***/ }),

/***/ 6644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__yHGzn","section__image":"styles_section__image__3wu_0","section__separator":"styles_section__separator__jTwxZ","section__overlay":"styles_section__overlay__S4fzZ","section__video":"styles_section__video__aGMVE","section__video--grayscale":"styles_section__video--grayscale__cSkkv","section--separator-large":"styles_section--separator-large__e2xv7","section--has-separator":"styles_section--has-separator__9vXz9","section--separator-top":"styles_section--separator-top__EcwNQ","section--gray":"styles_section--gray__GL0Sw","section--white":"styles_section--white__NJa_K","section--contained":"styles_section--contained__Laf5M","section--center":"styles_section--center__LmG2q","section--primary":"styles_section--primary__GuN0k","section--darker":"styles_section--darker__uJmer","section--bg-body":"styles_section--bg-body__g_dZD","section--o-hidden":"styles_section--o-hidden__xJTM8","section--with-bg":"styles_section--with-bg__fgmbo","section--pt0":"styles_section--pt0__IoFne","section--full-height":"styles_section--full-height__xFIuY","section--bottom":"styles_section--bottom__hRh3f","section--p0":"styles_section--p0__CiUN0","section--pb0":"styles_section--pb0__OvCBe","section--p-xs":"styles_section--p-xs__AOSqe","section--p-xl":"styles_section--p-xl__9nhJz","section--z-7":"styles_section--z-7__RDdr0"};

/***/ }),

/***/ 19403:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ya5V9","form__field":"styles_form__field__oUYqR","form__error":"styles_form__error__JtJGS","form__button":"styles_form__button__RJpQ8","form--large":"styles_form--large__ZDwXG","form--mobile-full":"styles_form--mobile-full__wI5pf"};

/***/ }),

/***/ 24055:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__mmYVw","footer__section":"styles_footer__section__2onyX","footer__title":"styles_footer__title__p4BvZ","footer__description":"styles_footer__description__xBuWb","footer__heading":"styles_footer__heading__t2rRE","footer__link":"styles_footer__link__UDIU6","footer__link--is-active":"styles_footer__link--is-active__YwONe","footer__link--disabled":"styles_footer__link--disabled__rSYVh","footer__wrapper":"styles_footer__wrapper__5sDAk","footer__external":"styles_footer__external__wxRXM","footer__column":"styles_footer__column__lpC5I","footer__copyright":"styles_footer__copyright__DeKrm","highlight":"styles_highlight__pfFZP"};

/***/ }),

/***/ 16174:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _castPath_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27449);
/* harmony import */ var _isArguments_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29169);
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27771);
/* harmony import */ var _isIndex_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56009);
/* harmony import */ var _isLength_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1656);
/* harmony import */ var _toKey_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62281);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = (0,_castPath_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = (0,_toKey_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && (0,_isLength_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(length) && (0,_isIndex_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(key, length) &&
    ((0,_isArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(object) || (0,_isArguments_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(object));
}

/* harmony default export */ __webpack_exports__["Z"] = (hasPath);


/***/ })

}]);